'use client'

import { AuthProvider } from '@/contexts/auth-context'
import { FetchProvider } from './fetch-provider'
import { FeedbackProvider } from '@/contexts/FeedbackContext'

export function Providers({ children }: { children: React.ReactNode }) {
  // console.log('Providers rendering');
  
  return (
    <AuthProvider>
      <FetchProvider>
        <FeedbackProvider>
          {children}
        </FeedbackProvider>
      </FetchProvider>
    </AuthProvider>
  )
}